@if (showComponent()) {
    <div class="input-group">
        <div class="input-group-btn">
            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                id="deleteFeaturesToolBtn"
                [title]="getTooltip()"
                [disabled]="isDisabled()"
                (click)="deleteAllSelectedFeatures()">
                <i class="nlrp-icon nlrp-icon-trash"></i>
            </button>
        </div>
        <ng-select
            class="nlr-ng-select nlr-ng-select-ribbon nlr-ng-select-button"
            [searchable]="false"
            [clearable]="false"
            id="deleteFeaturesDropdown"
            [disabled]="isDisabled()"
            [items]="removalTypes"
            [ngModel]="selectedRemovalType">
            <ng-template
                ng-option-tmp
                let-removalType="item">
                <div
                    [title]="removalType.tooltip"
                    (click)="executeRemovalType(removalType)">
                    <span class="text-left text-nowrap">{{removalType.label}}</span>
                </div>
            </ng-template>
        </ng-select>
    </div>
}
<div class="placeholder"></div>
